import { Dialog, Button, Text, TextLink } from '@machobear/design-system'
import { useTranslation, Trans } from 'react-i18next'

import IdVerification from './illustration/id-verification.svg?react'

type Props = {
  visible: boolean
  title?: string
  onClose: () => void
  width?: 'small' | 'content' | 'xsmall' | 'medium' | 'large' | 'xlarge' | undefined
  onSubmit?: () => void
}

const Description = () => {
  const { t } = useTranslation()

  return (
    <Trans i18nKey="l.standalone_trustscore.form_verification_pending_title" t={t}>
      <Text tone="secondary" align="center">
        We’ll send an email when we’ve completed verifying your ID. Once verified, you’ll receive
        access to the{' '}
        <TextLink target="_blank" href="https://liv.rent/blog/livrent/rental-verification-process/">
          Trust Score
        </TextLink>{' '}
        - our comprehensive tenant screening tool.
      </Text>
    </Trans>
  )
}

const IdVerificationPendingModal = ({ width = 'xsmall', visible, onClose, onSubmit }: Props) => {
  const { t } = useTranslation()

  const handleSubmit = () => {
    onSubmit?.()
    onClose()
  }
  return (
    <Dialog
      id="id-verification-pending-modal"
      open={visible}
      onClose={onClose}
      width={width}
      title={t(
        'l.listing.application.secure_docs.id_verification_required.heading',
        'ID Verification in progress...'
      )}
      illustration={<IdVerification />}
      description={<Description />}
    >
      <Button onClick={handleSubmit}>
        {t('l.standalone_trustscore.list.start_screening.text', 'Start Screening')}
      </Button>
    </Dialog>
  )
}

export default IdVerificationPendingModal
